import { useEffect } from "react";

/**
 * THE ONE WAY A PAGE TITLES THE DOCUMENT, on both surfaces (copy-1: App
 * adopted it when Product approved its titles, 2026-10-06).
 * `npm run quality:contracts` (scripts/lib/one-way-contracts.js,
 * `document-title`) refuses `document.title` anywhere else.
 *
 * `text` is a VISIBLE page heading, an approved title string or the public
 * business name. `context` is an optional public name that follows it (the
 * booking outcome's "Booking details · <business> · Lura"); blank or absent,
 * it is left out with its separator. Never URL, query, token, action code,
 * email or other client data: a title outlives the page in tab strips,
 * history and bookmarks. `"Lura"` alone is the untitled state (loading,
 * redirects, the router's own error).
 */
export function usePageTitle(text: string, context?: string | null): void {
  const extra = context?.trim() ?? "";
  useEffect(() => {
    document.title = text === "Lura" ? text : [text, extra, "Lura"].filter((part) => part !== "").join(" · ");
    // A page without its own title must not inherit the previous business or step.
    return () => { document.title = "Lura"; };
  }, [text, extra]);
}
